import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { ValidateId } from '../id-validator';
import { LeadService } from '../services/lead.service';
import { QuestionnaireService } from '../services/questionnaire.service';
import { SystemTablesService } from '../services/system-tables.service';
import { data } from '../../israel-cities';
import { Observable } from 'rxjs/Observable';
import { map, startWith } from 'rxjs/operators';
import { dataBabks } from '../banks';
import { GetConsultantDetails } from '../models/getConsultantDetails';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { OtpService } from '../services/otp.service';
import { Draft } from '../services/draft.service';
import { continueProcess } from '../models/ContinueProcess_Request';
import { DraftHttpService } from '../services/draft-http.service';
import { GetDraft_Request } from '../models/GetDraft_Request';
import { TranslateService } from '@ngx-translate/core';
import { GetDraft_Response } from '../models/GetDraft_Response.model';

interface ConsultingCompany {
	mkey: string;
	mtext: string;
	mEngText: string;
	shem_napa: string;//city
}

@Component({
	selector: 'app-advisors',
	templateUrl: './advisors.component.html',
	styleUrls: ['./advisors.component.scss']
})

export class AdvisorsComponent implements OnInit, AfterViewInit {
	advisors: FormGroup;
	consulting: FormControl
	prevQID: any;
	private route$: Subscription;
	qID: any;
	currentStep;
	visibleQids;
	currentStepName;
	isMobilePhone: boolean;
	submitted;
	editQuestion;
	isMobilePrefixOnly: boolean = true;
	DATA: any = data;
	public consultingCom;
	consultingCompanies: Observable<ConsultingCompany[]>;
	hasLoggedInAdvisor = false;
	tzAdvisor: string;
	advisorProcess: number;
	isError = "";
	draftNotExist = false;
	isloading = false;
	errorInConfirm = "";
	isDevMode: boolean;

	// optionsConsultingCompany
	// selectedConsultingCompany
	cities;
	qFields = {
		0: [],
		1: [{ name: "idNumber", validators: [Validators.required, ValidateId] }],
		2: [
			{ name: "firstName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "lastName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }
		],
		3: [{ name: "phoneNumber", validators: [Validators.required, this.validatePhone(), Validators.pattern("^[0-9]*$")] }],
		4: [{ name: "consulting", validators: [Validators.required, this.isInList()] }],
		5: [{ name: "idNumberCustomer", validators: [Validators.required, ValidateId] }]
		// 6: [{ name: "consultingCompany" }]
	};

	constructor(
		private fb: FormBuilder,
		private questionnaireService: QuestionnaireService,
		private activeRoute: ActivatedRoute,
		private router: Router,
		private leadService: LeadService,
		private httpClient: HttpClient,
		private systemTablesService: SystemTablesService,
		private otpService: OtpService,
		private draft: Draft,
		private translate: TranslateService,
		private draftHttpService: DraftHttpService
	) {

		this.cities = this.DATA.Cities;
		// this.getSystemTbl();
		this.currentStep = this.questionnaireService.getStep("advisors");
		this.consulting = new FormControl(this.questionnaireService.getQuestion(this.currentStep, "4").answer.fields[0].answerValue);

	}

	ngOnInit() {
		this.questionnaireService.setIsAdvisor(true);
		this.questionnaireService.dataChangedEvent.subscribe(() => {
			this.advisors.reset();
		});

		this.createForm();

		this.route$ = this.activeRoute.params.subscribe(params => {
			console.log("-----------------------------> params", params);
			this.prevQID = this.qID;
			this.qID = params.qid;
			this.editQuestion = null;
			this.currentStepName = "advisors";


			if (params.qid === "all") {
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				this.clearPreviousQuestionValidators();
			} else {
				this.setValidators();
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				if (this.qID !== '0') {
					this.setFocusFirstComponent(this.qID);
				}
			}
		});

	}

	ngAfterViewInit(): void {
		this.setFocusFirstComponent('0');
	}

	private setFocusFirstComponent(qID) {
		if (qID === '0') {
			this.focusToElement(`button[type="submit"]`);
		} else if (qID === '1') {
			this.focusToElement(`input[aria-label="${this.translate.instant('ADVISORS.Q2.PH1')}"]`);
		} else if (qID === '2') {
			this.focusToElement(`input[aria-label="${this.translate.instant('ADVISORS.Q1.INPUT1_PH')}"]`);
		} else if (qID === '3') {
			this.focusToElement(`input[aria-label="${this.translate.instant('HELP_DIALOG.PHONE_NUMBER_PC')}"]`);
		} else if (qID === '4') {
			this.focusToElement(`input[aria-label="${this.translate.instant('ADVISORS.Q4.PH1')}"]`);
		} else if (qID === '5') {
			// this.focusToElement(`input[aria-label="${this.translate.instant('ADVISORS.Q2.PH1')}"]`);
			let selectedElement = this.returnElementFromSelector(`input[aria-label="${this.translate.instant('ADVISORS.Q2.PH1')}"]`);
			if (selectedElement) {
				this.focusSpecificElement(selectedElement);
			}

			selectedElement = this.returnElementFromSelector(`button[data-button-id="common-proceed-1"]`);
			if (selectedElement) {
				this.focusSpecificElement(selectedElement);
			}

			selectedElement = this.returnElementFromSelector(`button[data-button-id="common-proceed-2"]`);
			if (selectedElement) {
				this.focusSpecificElement(selectedElement);
			}
		}

	}

	createForm() {
		this.currentStep = this.questionnaireService.getStep("advisors");
		this.advisors = this.fb.group({
			idNumber: this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[0].answerValue,
			firstName: this.questionnaireService.getQuestion(this.currentStep, "2").answer.fields[0].answerValue,
			lastName: this.questionnaireService.getQuestion(this.currentStep, "2").answer.fields[1].answerValue,
			phoneNumber: this.questionnaireService.getQuestion(this.currentStep, "3").answer.fields[0].answerValue,
			consulting: this.consulting,
			idNumberCustomer: this.questionnaireService.getQuestion(this.currentStep, "5").answer.fields[0].answerValue
		});
	}

	checkEmail() {
		return (control: AbstractControl): { [key: string]: any } => {
			var res = control.parent.controls["email"].value.substr(control.parent.controls["email"].value.indexOf("@"), control.parent.controls["email"].value.length);
			res = res.substr(res.indexOf("."), res.length);
			let str = res.substr(1, res.length)
			if (str.indexOf(".") != -1) {
				let string1 = str.substr(0, str.indexOf("."));
				let string2 = str.substr(str.indexOf(".") + 1, str.length);
				if (string1.length < 2 || string1.length > 7) {
					return { pattern: true };
				}
				else {
					if (string2.indexOf(".") != -1) {
						str = string2.substr(0, string2.indexOf("."));
						let string3 = string2.substr(string2.indexOf(".") + 1, string2.length);
						if (str.length < 2 || str.length > 7) {
							return { pattern: true };
						}
						else {
							if (string3.indexOf(".") != -1) {
								string3 = string3.substr(0, string3.indexOf("."));
								let string4 = string3.substr(string3.indexOf(".") + 1, string3.length);
								if ((string3.length < 2 || string3.length > 7 || string3.indexOf(".") != 0) && (string4.length < 2 || string4.length > 7 || string4.indexOf(".") != 0)) {
									return { pattern: true };
								}
							}
							else {
								if (string3.length < 2 || string3.length > 7) {
									return { pattern: true };
								}
							}
						}
					}
					else {
						if (string2.length < 2 || string2.length > 7) {
							return { pattern: true };
						}
					}
				}
			}
			else {
				if (str.length < 2 || str.length > 7) {
					return { pattern: true };
				}
			}
		}
	}

	validatePhone(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } => {
			if (control.value.includes("בחר")) {
				return {
					required: true
				};
			}
			if (this.isMobilePhone && control.value && control.value.length < 10) {//isMobilePhone not working
				return {
					minlength: true
				};
			} else if (!this.isMobilePhone && control.value && control.value.length < 9) {//isMobilePhone not working
				return {
					minlength: true
				};
			}
		};
	}

	loading() {
		this.isloading = !this.isloading;
	}

	setValidators() {
		// if (this.prevQID) {
		this.clearPreviousQuestionValidators();
		// }
		for (let i = 0; i < this.qFields[this.qID].length; i++) {
			let field = this.qFields[this.qID][i];
			this.advisors.controls[field.name].setValidators(field.validators);
			this.advisors.controls[field.name].updateValueAndValidity();
		}
		this.submitted = false;
	}

	setValidatorsArray() {
		this.questionnaireService.clearAllQuestionValidators(this.advisors.controls, this.qFields, false);
		this.questionnaireService.setCurrentQuestionValidators(this.qID, this.advisors.controls, this.qFields, "2", false);

		this.submitted = false;
	}

	clearPreviousQuestionValidators() {
		console.log("clearPreviousQuestionValidators()");

		let keys = Object.keys(this.qFields);

		for (let i = 0; i < keys.length; i++) {

			for (let j = 0; j < this.qFields[keys[i]].length; j++) {
				this.advisors.controls[this.qFields[keys[i]][j].name].setValidators(null);
				this.advisors.controls[this.qFields[keys[i]][j].name].updateValueAndValidity();
			}
		}
	}

	getConsultantDetails$(id) {
		let params: GetConsultantDetails = {
			ConsultantIdnt: id,
			SystemCode: "3"
		};
		const url = environment.apiUri + "/TofesMashkanta/GetConsultantDetails";
		return this.httpClient.post(url, params);
	}
	NavigateToStart() {
		this.router.navigate(["/questionnaire/advisors", 0]);
		this.draftNotExist = false;
	}
	setAdvisorProcess(process) {
		if (!this.questionnaireService.isLoginAdvisor) {
			this.advisorProcess = process;
			//this.onSubmit({ value: [], valid: true });
		}
	}

	ifIsLoginAdvisor() {
		return this.questionnaireService.isLoginAdvisor;
	}


    nextClick(qID, answers) {
        if (qID === "1" && answers) {
            this.questionnaireService.isLoginAdvisor = true;
            // if (environment.env === "dev") {
            // 	this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
            // 	this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
            // 	this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
            // 	this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
            // 	let firstName = "בדיקה";
            // 	let lastName = "יועץ";
            // 	this.draft.ConsultantId = answers[0];
            // 	this.draft.ConsultantIdnt = "0" + answers[0];
            // 	let temparr = [];
            // 	temparr.push(firstName)
            // 	temparr.push(lastName)
            // 	this.questionnaireService.updateMetaData(this.currentStep, "2", temparr);
            // 	this.questionnaireService.saveAndNavigate(this.currentStep, "2", temparr);
            // 	this.advisors.controls["firstName"].setValue("בדיקה");
            // 	this.advisors.controls["lastName"].setValue("יועץ");
            // 	let phoneNumber = "0524377225";
            // 	temparr = [];
            // 	temparr.push(phoneNumber)
            // 	this.questionnaireService.updateMetaData(this.currentStep, "3", temparr);
            // 	this.questionnaireService.saveAndNavigate(this.currentStep, "3", temparr);
            // 	this.advisors.controls["phoneNumber"].setValue("0524377225");
            // 	let consulting = "מזרחי טפחות";
            // 	this.draft.ConsultFirmId = "20";
            // 	temparr = [];
            // 	temparr.push(consulting)
            // 	this.questionnaireService.updateMetaData(this.currentStep, "4", temparr);
            // 	this.questionnaireService.saveAndNavigate(this.currentStep, "4", temparr);
            // 	this.advisors.controls["consulting"].setValue("מזרחי טפחות");
            // 	this.hasLoggedInAdvisor = false;
            // }

            this.loginAdvisor(answers[0]);
            this.otpService.getOtpStatus().subscribe(value => {
                if (value === "finish") {
                    this.getConsultantDetails$(answers[0]).subscribe((res: any) => {
                        console.log(res);
                        this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
                        this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
                        let firstName = res.ConsultantName.split(" ")[0];
                        let lastName = res.ConsultantName.split(" ")[1];
                        this.draft.ConsultantId = res.ConsultantId;
                        this.draft.ConsultantIdnt = res.ConsultantIdnt;
                        let temparr = [];
                        temparr.push(firstName)
                        temparr.push(lastName)
                        this.questionnaireService.updateMetaData(this.currentStep, "2", temparr);
                        this.questionnaireService.saveAndNavigate(this.currentStep, "2", temparr);
                        this.advisors.controls["firstName"].setValue(res.ConsultantName.split(" ")[0]);
                        this.advisors.controls["lastName"].setValue(res.ConsultantName.split(" ")[1]);
                        let phoneNumber = res.ConsultantPrefixPhone + res.ConsultantPhoneNumber;
                        temparr = [];
                        temparr.push(phoneNumber)
                        this.questionnaireService.updateMetaData(this.currentStep, "3", temparr);
                        this.questionnaireService.saveAndNavigate(this.currentStep, "3", temparr);
                        this.advisors.controls["phoneNumber"].setValue(res.ConsultantPrefixPhone + res.ConsultantPhoneNumber);
                        let consulting = res.Firms[0].ConsultFirmName;
                        this.draft.ConsultFirmId = res.Firms[0].ConsultFirmId;
                        temparr = [];
                        temparr.push(consulting)
                        this.questionnaireService.updateMetaData(this.currentStep, "4", temparr);
                        this.questionnaireService.saveAndNavigate(this.currentStep, "4", temparr);
                        this.advisors.controls["consulting"].setValue(res.Firms[0].ConsultFirmName);
                        this.hasLoggedInAdvisor = false;
                    },
                        (res) => {
                            this.errorInConfirm = this.translate.instant('USER_DETAILS.Q4.ERROR_IN_EXECUTING_ACTION');
                        });
                }
            });

        }
		else if (qID === "5" && this.advisorProcess === 2) {
			this.isloading = true;
			let params: continueProcess = {
				userId: this.advisors.controls["idNumberCustomer"].value,
				ConsultantId: this.draft.ConsultantId,
				ConsultantIdnt: this.draft.ConsultantIdnt
			};
			this.continueProcess$(params).subscribe(res => {
				this.isError = "";
				let params: GetDraft_Request = {
					userId: this.advisors.controls["idNumberCustomer"].value
				};
				this.draftHttpService.getDraft$(params).subscribe(
					(res: GetDraft_Response) => {
						console.log(res);
						this.questionnaireService.setAsmachta(res.oppID);
						this.draft.arrDataBase = res.draft;
						this.draft.updateSavedDraft(res.draft);
						this.draft.autoForm = true;
						//this.questionnaireService.setIsAdvisor(true);
						this.router.navigate(["/questionnaire/user-details", 1]);
						this.isloading = false;
					}, err => {
						this.isError = this.translate.instant('USER_DETAILS.Q4.ERROR_IN_EXECUTING_ACTION');
						this.isloading = false;
					});
			}, err => {
				this.draftNotExist = true;
				this.isloading = false;
			});
		}

	}

	continueProcess$(params: continueProcess) {
		let apiUri = environment.apiUri + "/TofesMashkanta";
		const url = `${apiUri}/continueProcess`;
		return this.httpClient.post(url, params);
	}


	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit():  value=", value, "valid=", valid);
		if (this.qID === "0" || this.qID === "5" && this.advisorProcess === 1) {
			this.questionnaireService.updateMetaData(this.currentStep, this.qID, []);
			this.questionnaireService.saveAndNavigate(this.currentStep, this.qID, []);
		}
		this.submitted = true;
		if (!valid) {
			this.questionnaireService.submitForm(true);
		}
		else {
			this.questionnaireService.submitForm(false);
		}
		if (valid) {
			let q;
			let submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;
			q = this.qFields[submitQID];

			let values = q.map(r => {
				return value[r.name];
			});

			if (this.qID !== "0") {//0 = intro
				this.questionnaireService.sendGA(this.currentStep, this.qID, values);
			}
			this.nextClick(submitQID, values);

		}
	}

	loginAdvisor(tz: string) {
		this.hasLoggedInAdvisor = true;
		this.tzAdvisor = tz;
	}

	editQuestionChange(qid) {
		this.qID = qid;
		this.setValidators();
	}
	isInList() {
		return (control: AbstractControl): { [key: string]: any } => {
			if (control.value && control.value.length > 0) {
				if (this.consultingCom) {
					let companyBingo = this.consultingCom.filter(consultingCompany => consultingCompany.mtext === control.value);
					if (companyBingo.length < 1) {
						return { isNotInList: true };
					}
					else return null;
				}
				return null;
			}
		}
	}

	returnElementFromSelector(selector: string) {
		const selectedElement = Array.from(document.querySelectorAll(selector));
		return selectedElement && selectedElement.length > 0 ? selectedElement[0] : null
	}

	focusSpecificElement(selectedElement: any) {
		const nowActiveElement = document.activeElement;
		(nowActiveElement as HTMLElement).blur();
		setTimeout(() => (selectedElement as HTMLElement).focus(), 0);
	}

	focusToElement(selector: string) {
		const selectedElement = Array.from(document.querySelectorAll(selector));

		if (selectedElement && selectedElement.length > 0) {
			const nowActiveElement = document.activeElement;
			(nowActiveElement as HTMLElement).blur();
			setTimeout(() => (selectedElement[0] as HTMLElement).focus(), 0);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/advisors/advisors.component.ts